//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './FirmwareClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetFirmwareQueryParameters = {
  generation?: string | null | undefined ;
  targetLanguage?: string | undefined ;
}

export type GetLinkFirmwareQueryParameters = {
  generation?: string | undefined ;
  subtype?: string | undefined ;
  getOlderVersion?: boolean | null | undefined ;
}

export function getUrl(generation?: string | null | undefined, targetLanguage?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/fw?";
if (generation !== undefined && generation !== null)
    url_ += "generation=" + encodeURIComponent("" + generation) + "&";
if (targetLanguage === null)
    throw new Error("The parameter 'targetLanguage' cannot be null.");
else if (targetLanguage !== undefined)
    url_ += "targetLanguage=" + encodeURIComponent("" + targetLanguage) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.FwResponseDto[], unknown, Types.FwResponseDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.FwResponseDto[], unknown, Types.FwResponseDto[]>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetFirmwareQueryParameters): QueryKey;
export function getQueryKey(generation?: string | null | undefined, targetLanguage?: string | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { generation, targetLanguage,  } = params[0] as GetFirmwareQueryParameters;

    return trimArrayEnd([
        'FirmwareClient',
        'get',
        generation as any,
        targetLanguage as any,
      ]);
  } else {
    return trimArrayEnd([
        'FirmwareClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as string | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.FwResponseDto[], TError = unknown>(dto: GetFirmwareQueryParameters, options?: Omit<UseQueryOptions<Types.FwResponseDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets firmware data from bucharest.
 * @param generation (optional) 
 * @param targetLanguage (optional) 
 */
export function useGetQuery<TSelectData = Types.FwResponseDto[], TError = unknown>(generation?: string | null | undefined, targetLanguage?: string | undefined, options?: Omit<UseQueryOptions<Types.FwResponseDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.FwResponseDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.FwResponseDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let generation: any = undefined;
  let targetLanguage: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ generation, targetLanguage,  } = params[0] as GetFirmwareQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [generation, targetLanguage, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.FwResponseDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(generation, targetLanguage),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.FwResponseDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets firmware data from bucharest.
 * @param generation (optional) 
 * @param targetLanguage (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.FwResponseDto[] | undefined) => Types.FwResponseDto[], generation?: string | null | undefined, targetLanguage?: string | undefined) {
  queryClient.setQueryData(getQueryKey(generation, targetLanguage),
    updater
  );
}

/**
 * Gets firmware data from bucharest.
 * @param generation (optional) 
 * @param targetLanguage (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.FwResponseDto[] | undefined) => Types.FwResponseDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function getLinkUrl(generation?: string | undefined, subtype?: string | undefined, getOlderVersion?: boolean | null | undefined): string {
  let url_ = getBaseUrl() + "/api/fw/link?";
if (generation === null)
    throw new Error("The parameter 'generation' cannot be null.");
else if (generation !== undefined)
    url_ += "generation=" + encodeURIComponent("" + generation) + "&";
if (subtype === null)
    throw new Error("The parameter 'subtype' cannot be null.");
else if (subtype !== undefined)
    url_ += "subtype=" + encodeURIComponent("" + subtype) + "&";
if (getOlderVersion !== undefined && getOlderVersion !== null)
    url_ += "getOlderVersion=" + encodeURIComponent("" + getOlderVersion) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getLinkDefaultOptions: Omit<UseQueryOptions<string, unknown, string>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<string, unknown, string>, 'queryFn'>> = {
};
export function getGetLinkDefaultOptions() {
  return getLinkDefaultOptions;
};
export function setGetLinkDefaultOptions(options: typeof getLinkDefaultOptions) {
  getLinkDefaultOptions = options;
}

export function getLinkQueryKey(dto: GetLinkFirmwareQueryParameters): QueryKey;
export function getLinkQueryKey(generation?: string | undefined, subtype?: string | undefined, getOlderVersion?: boolean | null | undefined): QueryKey;
export function getLinkQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { generation, subtype, getOlderVersion,  } = params[0] as GetLinkFirmwareQueryParameters;

    return trimArrayEnd([
        'FirmwareClient',
        'getLink',
        generation as any,
        subtype as any,
        getOlderVersion as any,
      ]);
  } else {
    return trimArrayEnd([
        'FirmwareClient',
        'getLink',
        ...params
      ]);
  }
}
export function __getLink(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getLink(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as string | undefined,       context.queryKey[4] as boolean | null | undefined,axiosConfig    );
}

export function useGetLinkQuery<TSelectData = string, TError = unknown>(dto: GetLinkFirmwareQueryParameters, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets firmware download link.
 * @param generation (optional) 
 * @param subtype (optional) 
 * @param getOlderVersion (optional) 
 */
export function useGetLinkQuery<TSelectData = string, TError = unknown>(generation?: string | undefined, subtype?: string | undefined, getOlderVersion?: boolean | null | undefined, options?: Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetLinkQuery<TSelectData = string, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<string, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let generation: any = undefined;
  let subtype: any = undefined;
  let getOlderVersion: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ generation, subtype, getOlderVersion,  } = params[0] as GetLinkFirmwareQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [generation, subtype, getOlderVersion, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<string, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getLink(context, axiosConfig) : __getLink,
    queryKey: getLinkQueryKey(generation, subtype, getOlderVersion),
    ...getLinkDefaultOptions as unknown as Omit<UseQueryOptions<string, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets firmware download link.
 * @param generation (optional) 
 * @param subtype (optional) 
 * @param getOlderVersion (optional) 
 */
export function setGetLinkData(queryClient: QueryClient, updater: (data: string | undefined) => string, generation?: string | undefined, subtype?: string | undefined, getOlderVersion?: boolean | null | undefined) {
  queryClient.setQueryData(getLinkQueryKey(generation, subtype, getOlderVersion),
    updater
  );
}

/**
 * Gets firmware download link.
 * @param generation (optional) 
 * @param subtype (optional) 
 * @param getOlderVersion (optional) 
 */
export function setGetLinkDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: string | undefined) => string) {
  queryClient.setQueryData(queryKey, updater);
}